import { render, staticRenderFns } from "./AccessibilityIconTable.vue?vue&type=template&id=669e6f62&scoped=true"
import script from "./AccessibilityIconTable.vue?vue&type=script&lang=js"
export * from "./AccessibilityIconTable.vue?vue&type=script&lang=js"
import "./AccessibilityIconTable.vue?vue&type=style&index=0&id=669e6f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669e6f62",
  null
  
)

export default component.exports